import { SeasonalRuleColor } from './SeasonalRule';

export const SEASONAL_RULE_COLOR_HEX: Record<SeasonalRuleColor, string> = {
  [SeasonalRuleColor.BLUE]: '#3A84D8',
  [SeasonalRuleColor.GREEN]: '#40caa1',
  [SeasonalRuleColor.PINK]: '#f7a3c4',
  [SeasonalRuleColor.PURPLE]: '#8a5bda',
  [SeasonalRuleColor.YELLOW]: '#ffc454',
};
